import { render, staticRenderFns } from "./VaimoCheckbox.vue?vue&type=template&id=55c38457&scoped=true&"
import script from "./VaimoCheckbox.vue?vue&type=script&lang=js&"
export * from "./VaimoCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VaimoCheckbox.vue?vue&type=style&index=0&id=55c38457&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c38457",
  null
  
)

export default component.exports